module.exports = __webpack_public_path__ + "public/img/longmndiao.2a48d8dc.png";